// eslint-disable-next-line import/prefer-default-export

export const getSetting = /* GraphQL */ `
    query GetSetting($key: String!) {
        getSetting(key: $key) {
            key
            value
        }
    }
`;

export const getUser = /* GraphQL */ `
    query GetUser($id: ID!) {
        getUser(id: $id) {
            id
            username
            name {
                first
                last
            }
            ensembleIds
            instrumentIds
        }
    }
`;

export const getInstrument = /* GraphQL */ `
    query GetInstrument($id: ID!) {
        getInstrument(id: $id) {
            id
            name
            ensembles {
                items {
                    ensemble {
                        id
                        name
                        code
                        parts
                        hasParts
                        state {
                            enabled
                        }
                    }
                }
            }
        }
    }
`;
export const getInstrumentBySlug = /* GraphQL */ `
    query GetInstrumentBySlug(
        $slug: String!
        $sortDirection: ModelSortDirection
        $filter: ModelInstrumentFilterInput
        $limit: Int
        $nextToken: String
    ) {
        getInstrumentBySlug(
            slug: $slug
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                slug
                name
                ensembles {
                    items {
                        ensemble {
                            id
                            name
                            code
                            parts
                            hasParts
                            state {
                                enabled
                            }
                        }
                    }
                }
            }
            nextToken
        }
    }
`;

export const listApplications = /* GraphQL */ `
    query ListApplications(
        $instrumentId: ID
        $filter: ModelApplicationFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listApplications(
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                festival {
                    name
                    zone {
                        name
                    }
                }
                instrument {
                    id
                    name
                }
                student {
                    id
                    name {
                        first
                        last
                    }
                    school {
                        id
                        name {
                            legal
                        }
                    }
                    applications(filter: { applicationInstrumentId: { ne: $instrumentId } }) {
                        items {
                            id
                            instrument {
                                name
                            }
                            festival {
                                name
                            }
                            ranking {
                                local
                                score
                            }
                            selection {
                                id
                                part
                                ranking {
                                    state
                                }
                                ensemble {
                                    id
                                    name
                                    code
                                    hasParts
                                }
                                accepted
                                selectionEnsembleId
                            }
                        }
                    }
                }
                ranking {
                    score
                    local
                }
                selection {
                    id
                    part
                    ranking {
                        state
                    }
                    ensemble {
                        id
                    }
                    accepted
                    selectionEnsembleId
                }
            }
            nextToken
        }
    }
`;


export const getApplicationDetails = /* GraphQL */ `
    query GetApplication(
        $id: ID!
    ) {
        getApplication(id: $id) {
            id
            form {
                name
                type
            }
            student {
                id
                grade
                dob
                address {
                    line1
                    line2
                    city
                    state
                    zip
                }
                phone {
                    type
                    number
                    ext
                }
                email {
                    type
                    address
                }
            }
            questions {
                lastYear {
                    attended
                    group
                    part
                    chair
                }
                moreThanOne {
                    response
                    instruments
                }
                organizations {
                    school
                    other
                }
                experience {
                    instrument {
                        years
                        doubles
                    }
                    vocalJazzAccompaniment
                    jazzEnsemble
                    orchestral
                }
                previousSoloRating {
                    ninth {
                        grade
                        level
                    }
                    tenth {
                        grade
                        level
                    }
                }
            }
            grading {
                tone
                rhythmicSense
                leadership
                maturity
                articulation
                intonation
                citizenship
                diction
                flexibility
                generalMusicianship
                attitude
                technique
                sightReading
                responsibility
            }
            recommendation
            comments
        }
    }
`;

export const getApplication = /* GraphQL */ `
    query GetApplication(
        $id: ID!
    ) {
        getApplication(id: $id) {
            id
            festival {
                name
            }
            instrument {
                name
            }
            student {
                id
                name {
                    first
                    last
                }
                school {
                    id
                    name {
                        legal
                    }
                }
                applications {
                    items {
                        id
                        instrument {
                            name
                        }
                        festival {
                            name
                        }
                        ranking {
                            local
                            score
                        }
                        selection {
                            id
                            part
                            ranking {
                                state
                            }
                            ensemble {
                                id
                                name
                                code
                                hasParts
                            }
                            accepted
                        }
                    }
                }
            }
            ranking {
                score
                local
            }
            selection {
                id
                part
                ranking {
                    state
                }
                ensemble {
                    id
                }
                accepted
            }
        }
    }
`;
export const updateApplication = /* GraphQL */ `
    mutation UpdateApplication(
        $input: UpdateApplicationInput!
        $condition: ModelApplicationConditionInput
    ) {
        updateApplication(input: $input, condition: $condition) {
            id
        }
    }
`;

export const createSelection = /* GraphQL */ `
    mutation CreateSelection(
        $input: CreateSelectionInput!
        $condition: ModelSelectionConditionInput
    ) {
        createSelection(input: $input, condition: $condition) {
            id
            accepted
            part
            ranking {
                state
            }
            selectionApplicationId
            selectionEnsembleId
            createdAt
            updatedAt
        }
    }
`;
export const updateSelection = /* GraphQL */ `
    mutation UpdateSelection(
        $input: UpdateSelectionInput!
        $condition: ModelSelectionConditionInput
    ) {
        updateSelection(input: $input, condition: $condition) {
            id
            accepted
            part
            ranking {
                state
            }
            selectionApplicationId
            selectionEnsembleId
            createdAt
            updatedAt
        }
    }
`;
export const deleteSelection = /* GraphQL */ `
    mutation DeleteSelection(
        $input: DeleteSelectionInput!
        $condition: ModelSelectionConditionInput
    ) {
        deleteSelection(input: $input, condition: $condition) {
            id
        }
    }
`;

export const deleteInvoice = /* GraphQL */ `
    mutation DeleteInvoice(
        $input: DeleteInvoiceInput!
        $condition: ModelInvoiceConditionInput
    ) {
        deleteInvoice(input: $input, condition: $condition) {
            id
        }
    }
`;

export const onUpdateApplication = /* GraphQL */ `
    subscription OnUpdateApplication {
        onUpdateApplication {
            id
            student {
                id
            }
        }
    }
`;

